import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { assignSettingOnEvent } from "@faire/retailer-visitor-shared/settings/assignSettingOnEvent";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React from "react";

export const NoOpLayoutElement: React.FC = () => {
  const {
    layoutElement: { layout_element_data_assign_settings_on_client_view },
  } = React.useContext(Context);

  const viewRef = useDoActionWhenVisible(() => {
    layout_element_data_assign_settings_on_client_view.forEach((setting) => {
      assignSettingOnEvent(setting);
    });
  });

  return <div data-test-id="no-op-layout-element" ref={viewRef} />;
};
